import React from 'react';
import { Link as LinkMaterial } from '@material-ui/core';
import { Link as LinkRRD } from 'react-router-dom';

const LinkRouter = (props) => <LinkMaterial component={LinkRRD} {...props} />;

export default LinkRouter;
